export var getComponentPosition = function getComponentPosition(component) {
  if (!component) return;
  if (!component.offsetParent) return;
  return component.getBoundingClientRect();
};